module.exports = __webpack_public_path__ + "static/hauling-ec7360830792732ab2dcdb46167caaa8.jpg";